import React, {useState} from 'react';
import LetterList from '../Letter/List';
import Icon from '../../components/Icon';
import {useQuery} from '@apollo/client';
import {QUERY_USER} from './graphql';

const Chat = () => {
  const [isOpen, setIsOpen] = useState(false);

  const {user} = useQuery(QUERY_USER).data;
  const lastLetter = user.client.lastLetter;

  const newCount = lastLetter && lastLetter.isAdmin ? user.client.newCount : 0;

  return (
    <div
      className="container position-fixed bg-white border border-2 border-info rounded d-flex flex-column"
      style={{width: isOpen ? 400 : 'auto', top: isOpen ? 80 : undefined, right: 20, bottom: 20, zIndex: 10}}
    >
      <div className="col-auto">
        <div className="row align-items-center justify-content-end">
          {isOpen && (
            <div className="col">
              <div className="row px-3 py-2">
                <div className="col-auto">
                  <Icon name="comment" size={18} />
                </div>
                <div className="col-auto ms-2">Чат с админом {newCount ? `(${newCount})` : ''}</div>
              </div>
            </div>
          )}
          <div className="col-auto">
            <button
              className={`btn ${isOpen ? 'px-3 py-2' : 'px-3 py-3'} ${newCount && !isOpen ? 'blink_me' : ''}`}
              onClick={() => setIsOpen(!isOpen)}
            >
              <Icon name={isOpen ? 'chevron-down' : 'comment'} size={isOpen ? 26 : 32} color="info" />
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="col overflow-auto border-top">
          <LetterList />
        </div>
      )}
    </div>
  );
};

export default Chat;
